import React from 'react';
import Slider from 'react-slick';
import categoriasJson from './brandsJson.js';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import bgbrandsslick from '../images/bgbrandsslider.webp';

const ImageSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 15000,
    cssEase: 'linear', 
    slidesToShow: 6,
    slidesToScroll: 6,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          speed: 8000,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }
    ]
  };

  return (
    <section className='brandsTop' style={{ backgroundImage: `url(${bgbrandsslick})` }}>
        <div className='content'>
            <Slider {...settings}>
            {categoriasJson.map((cats) => {
                    let img = `${process.env.PUBLIC_URL}/images/brands/${cats.alt}.webp`;
                    return (
                    <li key={cats.titulo}>
                        <figure>
                        <img width="100%" src={img} alt={cats.titulo} className={cats.alt} loading="lazy"></img>
                        </figure>
                    </li>
                    );
                })}
            </Slider>
        </div>
    </section>
  );
}

export default ImageSlider;